'use client';

import { useTransition } from 'react';
import { trackStartedCheckoutKlaviyo } from '../../klaviyo/events';
import { removeGid } from '../../lib/utils';
import { redirectToCheckoutAction } from '../actions';
import { useCart, useCartTotals } from '../context';

export function useCartSummary() {
  const { cart } = useCart();
  const cartTotals = useCartTotals();
  const [isPending, startTransition] = useTransition();

  const handleCheckout = () => {
    startTransition(() => {
      if (cart) {
        // Track Klaviyo
        trackStartedCheckoutKlaviyo({
          totalValue: Number(cartTotals),
          items: cart.items.map((item) => ({
            ProductID: removeGid(item.variantId),
            ProductName: item.title,
            ProductURL: window.location.href,
            Price: Number(item.price.amount),
            Quantity: item.quantity,
          })),
        });

        redirectToCheckoutAction();
      }
    });
  };

  return {
    cart,
    cartTotals,
    isPending,
    handleCheckout,
  };
}
